import { Application } from "@hotwired/stimulus"

window.Stimulus = Application.start()
